<template>
   <div>
     <div class="heading">
       <div class="vld-parent">
            <loading :active.sync="isLoading" loader= 'bars' 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage"></loading>
        </div>
            <img class="dividerline" src="../assets/img/sep.png" alt="">
            <h2>Members' Roundup</h2>
            <img class="dividerline" src="../assets/img/sep.png" alt="">
            <!-- <img src="../assets/img/comingsoon.jpg" alt="" v-show="(info==null)" /> -->
            <ul style="text-align:left" v-for="(data, i) in info" :key="i">
                <li v-html="data.contentdesc"></li>
                <!-- <ul style="text-align:left" v-for="(imagepath, j) in data.contentimage" :key="j+1000">
                  <img :src="imagepath" style="width:100px"/>
                </ul> -->
                <div class="row" style="align-content:center">
                  <div style="text-align:left" v-for="(imagepath, j) in data.contentimage" :key="j">
                      <div class="restmenuwrap" >
                          <img style="height:150px" :src="imagepath"/> &nbsp;
                      </div> <br/>
                  </div>
              </div>
            </ul>
      </div>
   </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
  export default {
    name: 'Membersroundup',
    components: {
      Loading
    },
    data () {
      return {
        msg: 'Membersroundup',
        isLoading: false,
        fullPage: true,
        info: null,
    }
  },
  methods: {
    onCancel() {
              console.log('User cancelled the loader.')
            }
  },
   mounted () {
    this.isLoading = true;
    axios
      .get(process.env.NODE_API + '/membersroundups')
      .then(response => {
        this.info = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.isLoading = false)
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Membersroundup.vue